export default __webpack_public_path__ + "static/media/garden_rent.188ce2e1.jpeg";